<template>
  <!-- energyOverview 能耗概况 -->
  <div class="ut-page-list elec-report-efficiency-analysis container-component" style="background:#03142a">
    <div class="d2-container-full__body">
      <div>
        <div class="custom-crud">
        </div>
        <form class="el-form table-search-form-single el-form--inline flex">
          <div>
            <label style="padding: 0 10px;color: #fff;margin-left:10px">选择区域：</label>
            <el-select v-model="chartId" placeholder="请选择" class="quyu">
              <el-option label="区域A" value="1"></el-option>
              <el-option label="区域B" value="2"></el-option>
              <el-option label="区域C" value="3"></el-option>
              <el-option label="区域D" value="4"></el-option>
            </el-select>
          </div>
          <div>
            <label style="padding: 0 10px;color: #fff;margin-left:10px">能源类型：</label>
            <el-select v-model="leixing" placeholder="请选择" class="leixing">
              <el-option label="电" value="1"> </el-option>
              <el-option label="水" value="2"> </el-option>
              <el-option label="气" value="3"> </el-option>
              <el-option label="汽" value="4"> </el-option>
            </el-select>
          </div>
          <div>
            <label style="padding: 0 10px;color: #fff;margin-left:10px">设备类型：</label>
            <el-select v-model="leixing2" placeholder="请选择" class="leixing">
              <el-option label="空调" value="1"> </el-option>
              <el-option label="冰箱" value="2"> </el-option>
              <el-option label="电灯" value="3"> </el-option>
            </el-select>
          </div>
          <div>
            <label style="padding: 0 10px;color: #fff;margin-left:10px">时间范围：</label>
            <el-select v-model="itemType" placeholder="请选择" class="leixing">
              <el-option v-for="(item, index) in optionsDate" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="el-form-item form-adaption el-form-item--mini">
            <div v-if="itemType == 'day'">
              <label style="padding: 0 10px;color: #fff">查询时间：</label>
              <el-date-picker v-model="startTime" type="date" placeholder="选择日期" :picker-options="pickerOptions"
                value-forma="timestamp">
              </el-date-picker>
            </div>
            <div v-if="itemType == 'month'">
              <label style="padding: 0 10px;color: #fff">查询时间：</label>
              <el-date-picker v-model="startTime" type="date" placeholder="选择日期" :picker-options="pickerOptions"
                format="yyyy-MM-dd" value-forma="timestamp">
              </el-date-picker>
              <label style="padding: 0 10px;color: #fff">至</label>
              <el-date-picker v-model="endTime" type="date" placeholder="选择日期" :picker-options="pickerOptions"
                format="yyyy-MM-dd" value-forma="timestamp">
              </el-date-picker>
            </div>
            <div v-if="itemType == 'year'">
              <label style="padding: 0 10px;color: #fff">查询时间：</label>
              <el-date-picker v-model="startMonthTime" type="month" placeholder="选择日期" :picker-options="pickerOptions"
                format="yyyy-MM" value-format="timestamp">
              </el-date-picker>
              <label style="padding: 0 10px;color: #fff">至</label>
              <el-date-picker v-model="endMonthTime" type="month" placeholder="选择日期" format="yyyy-MM"
                :picker-options="pickerOptions" value-format="timestamp">
              </el-date-picker>
            </div>
            <div v-if="itemType == '自定义'">
              <label style="padding: 0 10px;color: #fff">查询时间：</label>
              <el-date-picker v-model="customStartTime" type="datetime" placeholder="选择日期"
                :picker-options="pickerOptions" default-time="00:00:00" format="yyyy-MM-dd HH-mm-ss"
                value-format="timestamp">
              </el-date-picker>
              <label style="padding: 0 10px;color: #fff">至</label>
              <el-date-picker v-model="customEndTime" type="datetime" placeholder="选择日期" :picker-options="pickerOptions"
                format="yyyy-MM-dd HH-mm-ss" value-format="timestamp">
              </el-date-picker>
            </div>
          </div>
          <div>
            <el-button icon="el-icon-search" type="primary">查询</el-button>

          </div>
        </form>
        <div class="line-list-row el-row">
          <div class="box_title">
            <div class="name">总用电量(kWh)：<div class="num">48862.00</div>
            </div>
            <div class="name">实时总功率(kW)：<div class="num">48862.00</div>
            </div>
          </div>
          <div class="row-item">
            <div class="box" v-for="index in 16" :key="index">
              <div class="p">
                <div class="tit">A10{{ index }}中央空调</div>
                <div class="status">
                  <div class="t " :class="{ 'active': index % 3 }">{{ index % 3 ? '在线' : '离线' }}</div>
                  <div class="i el-icon-more"></div>
                </div>
              </div>
              <div class="two">hb323423</div>
              <div class="three">实时功率：<div class="num"> {{ getMath(65.26) }} kW</div>
              </div>
              <div class="three four">累计用电：<div class="num2">{{ getMath(562.8) }} kWh</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <lossCurve ref="mylossCurve"></lossCurve>
    <losschart ref="mylosschart"></losschart>
  </div>
</template>


<style scoped lang="scss">
.box_title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;

  .name {
    font-family: Microsoft YaHei;
    font-size: 14px;
    color: #fff;
    display: flex;
    align-items: center;
    margin-right: 60px;

    .num {
      color: #FFB114;
      font-family: Microsoft YaHei;
      font-size: 20px;
      font-weight: bold;
    }
  }
}

.box {
  width: 296px;
  height: 146px;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 16px;
  background: #05224C;
  margin-right: 12px;
  margin-bottom: 12px;

  .p {
    display: flex;
    justify-content: space-between;

    .tit {
      font-family: Microsoft YaHei;
      font-size: 16px;
      font-weight: bold;
      font-variation-settings: "opsz" auto;
      color: #fff;
    }

    .status {
      display: flex;
      align-items: center;

      .t {
        width: 38px;
        height: 21px;
        border-radius: 4px;
        font-family: Microsoft YaHei;
        font-size: 13px;
        color: #fff;
        margin-right: 8px;
        text-align: center;
        line-height: 21px;
      }

      .active {
        color: #00FF94;
        background: rgba(43, 164, 113, 0.2);
      }

      .i {
        color: #999;
        transform: rotateZ(90deg);
      }
    }

  }

  .two {
    font-family: Microsoft YaHei;
    font-size: 13px;
    color: #999;
    margin-top: 2px;
    margin-bottom: 26px;
  }

  .three {
    display: flex;
    color: #CCC;
    font-family: Microsoft YaHei;
    font-size: 14px;

    .num {
      color: #fff;
    }

    .num2 {
      color: #FFB114;
    }
  }

  .four {
    margin-top: 11px;
  }
}

.row-item {
  display: flex;
  flex-wrap: wrap;

  .item {
    flex-shrink: 0;
    width: 454px;
    height: 314px;
    background-color: #143A76;
    border-radius: 5px;
    padding: 15px;
    color: #000;
    margin-right: 20px;
    margin-bottom: 20px;

    .item-title {
      font-size: 15px;
      font-weight: bold;
      margin-bottom: 20px;
    }

    .item-middle {
      display: flex;

      .z-left {
        width: 200px;
        height: 200px;
        // border: 1px solid red;
        margin-right: 20px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .z-right {
        .z-name {
          height: 36px;
          // line-height: 36px;
          display: flex;
          align-items: center;

          span {
            margin-left: 6px;
            font-size: 15px;
            font-weight: bold;
          }


        }

        .yellow {
          color: #FFC738;
          font-size: 30px;
          font-weight: bold;
          margin-top: 15px;
          margin-bottom: 25px;
        }

        .red {
          color: #FF7A50;
          font-size: 30px;
          font-weight: bold;
          margin-top: 15px;
        }
      }

    }

    .item-bottm {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      margin-top: 20px;
    }

  }
}

.d2-container-full__body {
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  /* height: 100%; */
  /* padding: 20px; */
  overflow: auto;
  position: relative;
}

/deep/.el-button {
  background-color: transparent !important;
  color: #000;
  height: 32px;
  line-height: 32px;
  padding: 0px 20px;

  &:hover {
    border-color: #409eff;
    background-color: #409eff !important;
  }
}

.ut-page-title-actions {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 52px;
  padding: 0 15px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background-color: #f8f8f9;
}

.custom-crud {
  padding: 5px 15px 10px;
  /* background-color: #000; */
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

.flex {
  display: flex;
}

/deep/.el-menu--horizontal>.el-menu-item {
  height: 40px;
  line-height: 40px;
}

.ut-page-title-actions .page-title-text {
  -webkit-box-flex: 1px;
  -ms-flex: 1px;
  flex: 1px;
  padding: 10px 7px;
  font-size: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.ut-page-title-actions .el-button {
  font-size: 14px;
  padding: 0 10px;
  position: relative;
  margin-left: 0;
}

.ut-page-list .el-form {
  /* background-color: #000; */
  /* padding: 35px 15px 0 25px; */
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 18px;
}

.ut-page-list .table-search-form-single .form-adaption {
  margin-right: 25px;
}

/deep/.el-input--suffix .el-input__inner {
  height: 32px;
  line-height: 32px;
  /* border-radius: 25px; */
  background-color: transparent;
  color: #000;
}

.ut-page-list .table-search-form-single .form-adaption .search-form-select input {
  height: 32px;
  line-height: 32px;
  background-color: transparent;
  color: #000;
  /* border-radius: 25px; */
}

/deep/.el-input__icon {
  line-height: 32px;

}

/deep/.el-button--small {
  padding: 3px 20px;
  border-radius: 20px;
}

.line-list-row {
  width: 100%;
  padding-top: 10px;
  margin: 0;
  /* background-color: #000; */
  min-height: 750px;
  padding-left: 19px;
  padding-bottom: 50px;
}

.el-row:after,
.el-row:before {
  display: table;
}

.ut-page-list .custom-card .el-card__body {
  padding: 10px;
}

.list {
  padding-left: 10px;
  padding-right: 10px;
  min-height: 176px;
  margin-bottom: 20px;
  display: table;
}

.el-card {
  border: 1px solid #ebeef5;
  background-color: #000;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  display: table-cell;
}

.el-row--flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.card-head-title {
  font-size: 15px;
  color: #000;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding-right: 5px;
}

.card-head-no {
  color: #909399;
}

.card-body {
  padding: 10px 0;
}

.el-row--flex.is-justify-space-between {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.card-body .grid-content>div {
  font-size: 13px;
  /*display: inline-block;*/
  /* width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
}

.card-body .grid-content .loss-info-value {
  padding: 7px 0;
}

.number {
  color: #303133;
  font-size: 24px;
  margin-right: 5px;
}

.el-col-0,
.el-row--flex:after,
.el-row--flex:before {
  display: none;
}

[class*="el-col-"] {
  float: left;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.card-body .grid-content {
  color: #909399;
  padding-left: 5px;
}

.card-bottom {
  border-top: 1px solid #ebeef5;
}

.card-bottom .btn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-top: 8px;
}

.card-bottom .btn .el-button {
  color: #909399;
}

.card-bottom .bd {
  border-left: 1px solid #ebeef5;
}

.color {
  color: rgb(244, 67, 54);
}

.ut-page-list .custom-crud {
  /* background-color: #000; */
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  text-align: right;
}

.ut-page-list .custom-crud .d2-crud-pagination {
  padding: 15px !important;
}

/deep/.el-menu {
  background: #fff !important;
}

/deep/.el-menu-item.is-active {
  background: #fff !important;
}

/deep/.el-menu-item-group .el-menu-item.demo:hover {
  background: #fff !important;
}

.t {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box !important;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
</style>
<script>

export default {
  components: {

  },
  data() {
    return {
      leixing: '1',
      leixing2: '1',
      itemType: "day", //时间类型
      time: new Date(new Date().toLocaleDateString()), //日 时间
      startTime: new Date(new Date().toLocaleDateString()), //月 开始时间
      endTime: new Date(), //月 结束时间
      startMonthTime: "", //年 开始时间
      endMonthTime: "", // 年 结束时间
      customStartTime: "", //自定义 开始时间
      customEndTime: "", //自定义 结束时间

      chartId: '1',//ID

      options: [],
      optionsDate: [
        {
          name: "日",
          id: "day"
        },
        {
          name: "月",
          id: "month"
        },
        {
          name: "年",
          id: "year"
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },

    };
  },
  mounted() {


  },

  methods: {
    getMath(index = 10) {
      //生成随机数
      let count = Math.round(Math.random() * index).toFixed(2);

      return count;
    },

  },
};
</script>
<style>
.container-component .el-button {
  color: #fff !important;
}

.container-component .el-input--suffix .el-input__inner {
  color: #fff !important;
}

.container-component .el-select .el-input__inner {
  color: #fff !important;
}
</style>
<style>
.d2-container-full__body .quyu input {
  width: 180px;
}

.d2-container-full__body .leixing input {
  width: 120px;
}
</style>